// src/stripe.js
import { loadStripe } from '@stripe/stripe-js';

// Replace 'your_stripe_publishable_key' with your actual Stripe publishable key
const stripePromise = loadStripe('pk_live_51OZ8VoCV8H3kriX2Erax8lq3krzzej9yXF3eaY28QhWB7WfIxYKqvqItjIbW3qkmQkn2d7tpqkD2rhUHTbTYGf9q00I2RR5WcV');

export default stripePromise;
